<template>
  <div class="case_details_wrap">
    <PCNavbar :selectIndex="3" />
    <MobileNavBar :currentActive="3" />
    <div class="case_content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="case_bread">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/case' }">客户案例</el-breadcrumb-item>
        <el-breadcrumb-item>案例详情</el-breadcrumb-item>
      </el-breadcrumb>

      <div v-if="caseData.image" class="case_detail">
        <!-- 案例图片 -->
        <div class="case_image_section">
          <div class="image_wrapper">
            <img :src="caseData.image" alt="案例图片" class="case_image" />
          </div>
        </div>
      </div>

      <div v-else class="no_case">
        <p>案例不存在或已下架</p>
        <el-button type="primary" @click="goBack">返回案例列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import { getCaseById } from '../../api/case'

export default {
  name: 'CaseDetail',
  components: {
    PCNavbar,
    MobileNavBar
  },
  data() {
    return {
      caseData: {},
      originalTitle: ''
    }
  },
  mounted() {
    this.originalTitle = document.title
    this.getCaseDetail()
  },
  beforeDestroy() {
    if (this.originalTitle) {
      document.title = this.originalTitle
    }
  },
  methods: {
    async getCaseDetail() {
      try {
        const res = await getCaseById(this.$route.params.id)
        if (res.data && res.data.data) {
          this.caseData = res.data.data
          this.updatePageTitle()
        }
      } catch (error) {
        console.error('获取案例详情失败:', error)
      }
    },
    updatePageTitle() {
      if (this.caseData && this.caseData.id) {
        document.title = '案例详情 - ' + this.caseData.id
      }
    },
    goBack() {
      this.$router.push('/case')
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.params.id !== from.params.id) {
        this.getCaseDetail()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.case_details_wrap {
  min-height: 100vh;
  background: #f5f7fa;
}

.case_content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px 40px;

  @media screen and (max-width: 768px) {
    padding: 80px 15px 30px;
  }
}

.case_bread {
  margin-bottom: 30px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.case_detail {
  background: #fff;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  @media screen and (max-width: 768px) {
    padding: 20px;
  }
}

.case_image_section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image_wrapper {
  max-width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.case_image {
  max-width: 600px;
  width: 100%;
  height: auto;
  object-fit: contain;

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
}

.no_case {
  text-align: center;
  padding: 100px 20px;
  background: #fff;
  border-radius: 12px;

  p {
    font-size: 18px;
    color: #999;
    margin-bottom: 30px;
  }
}
</style>
